module.exports = __webpack_public_path__ + "img/shart-3.860e3497.png";